import { createSlice } from '../wrappers';

const initialState = {
	selectedIndex: 0,
	maxIndex: 4,
};

const menuSelectionSlice = createSlice({
	name: 'menuSelection',
	initialState,
	reducers: {
		setSelectedIndex: (state, action) => {
			state.selectedIndex = action.payload;
		},
		setMaxIndex: (state, action) => {
			state.maxIndex = action.payload;
			if (state.selectedIndex > state.maxIndex) {
				state.selectedIndex = state.maxIndex;
			}
		},
		setSelectedIndexPrev: (state) => {
			const index = state.selectedIndex;
			state.selectedIndex = index > 0 ? index - 1 : index;
		},
		setSelectedIndexNext: (state) => {
			const index = state.selectedIndex;
			const maxIndex = state.maxIndex;
			state.selectedIndex = index < maxIndex ? index + 1 : index;
		},
	},
});

export const {
	setSelectedIndex,
	setMaxIndex,
	setSelectedIndexPrev,
	setSelectedIndexNext,
} = menuSelectionSlice.actions;

export default menuSelectionSlice.reducer;
